import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";

export const Route = createFileRoute("/_authenticated/admin/seherler")({
  component: Page,
});

function Page() {
  return (
    <div>
      <AdminPageHeader title="Şəhərlər" description="Elan yerləşdirmə üçün şəhər siyahısı" />
      <CrudManager
        table="cities"
        orderColumn="sort_order"
        ascending
        addLabel="Yeni şəhər"
        emptyText="Şəhər yoxdur."
        fields={[
          { name: "name", label: "Ad" },
          { name: "slug", label: "Qısa ünvan (slug)" },
          { name: "sort_order", label: "Sıra", type: "number" },
          { name: "active", label: "Aktiv", type: "boolean" },
        ]}
        columns={[
          { name: "name", label: "Ad" },
          { name: "slug", label: "Slug" },
          { name: "sort_order", label: "Sıra" },
          { name: "active", label: "Vəziyyət", render: (r) => (r["active"] ? "Aktiv" : "Deaktiv") },
        ]}
      />
    </div>
  );
}
